import BsIconButton from './index.vue'
export default BsIconButton